module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-left",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("./assets/Logo.png")
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "myNavbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("Home")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/verzetten",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Verzetten")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/shop",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Shop")])])], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#myNavbar"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('strong', [_vm._v("Tel")]), _vm._v("\n        +31 85 30 11 500\n        "), _c('strong', [_vm._v("Email")]), _vm._v("\n        info@fietsenmetvictor.nl\n\n\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0f74e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 19
// module chunks = 0